<template>
  <div class="first-step">
    <!-- <svg
      class="translateXFromLeft"
      viewBox="0 0 1838 912"
      :style="{
        position: 'absolute',
        width: 1920 * 0.3 + 'px',
        height: 1920 * 0.15 + 'px',
        top: 20 + '%',
        left: 12 + '%',
      }"
    >
      <path
        :fill="mainColor"
        d="M 1202,0.52 C 1182.50,5.76 1175.03,17.43 1175,37 1175,37 1175,100 1175,100 1175,111.67 1173.89,126.01 1177.76,137 1183.01,151.87 1197.39,157.98 1212,158 1212,158 1299,158 1299,158 1321.29,157.97 1337.89,146.77 1338,123 1338,123 1338,37 1338,37 1337.97,16.62 1326.73,0.03 1305,0 1305,0 1238,0 1238,0 1238,0 1202,0.52 1202,0.52 Z"
      />
      <path
        :fill="mainColor"
        d="M 513,118.52 C 496.29,123 486.03,133.10 486,151 486,151 486,241 486,241 486.11,263.56 501.24,275.97 523,276 523,276 610,276 610,276 631.96,275.97 648.89,264.41 649,241 649,241 649,155 649,155 648.97,134.89 637.40,118.03 616,118 616,118 549,118 549,118 549,118 513,118.52 513,118.52 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 348,123.15 C 342.36,124.68 337.97,125.80 333,128.95 318.48,138.15 319,151.95 319,167 319,167 319,199 319,199 319,213.77 317.25,230.17 328.18,241.96 335.38,249.71 345.85,251.98 356,252 356,252 406,252 406,252 411.53,251.99 414.60,251.77 420,250.25 443.84,243.56 445,227.11 445,206 445,206 445,181 445,181 445,165.48 446.87,148.34 437.21,135 428.17,122.51 415.69,123 402,123.15 402,123.15 372,123.15 372,123.15 372,123.15 348,123.15 348,123.15 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 933,156.14 C 933,156.14 915,159.77 915,159.77 894.65,166.02 878.10,182.92 878,205 878,205 878,358 878,358 878.01,366.19 878.65,368.37 881.58,376 890.57,399.37 910.86,409.96 935,410 935,410 1076,410 1076,410 1098.28,409.97 1122.20,400.15 1132.11,379 1135.88,370.95 1136.99,361.82 1137,353 1137,353 1137,216 1137,216 1136.96,192.10 1125.90,168.37 1102,160.10 1088.11,155.29 1070.59,156 1056,156.14 1056,156.14 988,156.14 988,156.14 988,156.14 933,156.14 933,156.14 Z"
      />
      <path
        :fill="mainColor"
        d="M 716,196.16 C 698.48,200.59 687.22,211.34 687,230 687,230 687,319 687,319 687.26,341.13 702.24,354.97 724,355 724,355 811,355 811,355 824.66,354.98 840.56,349.21 846.74,336 851.20,326.46 850,311.53 850,301 850,301 850,234 850,234 849.97,212.97 838.44,196.11 816,196.16 816,196.16 752,196.16 752,196.16 752,196.16 716,196.16 716,196.16 Z"
      />
      <path
        :fill="mainColor"
        d="M 1209,199.14 C 1196.79,201.43 1186.29,204.58 1179.48,216 1175.88,222.04 1175.01,230.10 1175,237 1175,237 1175,319 1175,319 1175.02,329.87 1177.03,339.57 1184.46,347.91 1192.52,356.95 1206.47,358.86 1218,359 1218,359 1293,359 1293,359 1307.36,358.98 1324.21,355.93 1332.61,343 1339.61,332.25 1338,319.22 1338,307 1338,307 1338,237 1338,237 1337.99,231.33 1337.94,229.54 1336.28,224 1335.19,220.38 1333.99,217.19 1331.89,214 1320.95,197.38 1302.36,199 1285,199.14 1285,199.14 1245,199.14 1245,199.14 1245,199.14 1209,199.14 1209,199.14 Z"
      />
      <path
        :fill="mainColor"
        d="M 244,274.11 C 244,274.11 226,277.77 226,277.77 205.30,284.13 189.03,300.55 189,323 189,323 189,476 189,476 189.05,508.54 215.21,527.95 246,528 246,528 387,528 387,528 409.53,527.96 435.09,517.30 443.73,495 449.46,480.23 448,455.16 448,439 448,439 448,337 448,337 447.99,328.92 446.71,320.83 444.76,313 443.71,308.77 441.79,304.81 439.69,301 424.76,273.97 398.96,274 372,274.11 372,274.11 337,274.11 337,274.11 337,274.11 307,274.11 307,274.11 307,274.11 244,274.11 244,274.11 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 520,317.21 C 520,317.21 509,319.60 509,319.60 495.10,324.15 486.07,335.30 486,350 486,350 486,441 486,441 486.03,461.84 500.16,475.97 521,476 521,476 611,476 611,476 633.47,475.96 648.96,463.16 649,440 649,440 649,355 649,355 648.98,340.61 642.74,326.55 629,320.35 619.39,316.01 601.73,317 591,317.21 591,317.21 520,317.21 520,317.21 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 30,387.22 C 24.99,388.38 22.64,388.92 18,391.27 0.36,400.22 1,414.99 1,432 1,432 1,463 1,463 1,477.40 -0.69,493.15 9.33,504.99 16.49,513.45 26.34,515.98 37,516 37,516 89,516 89,516 95.09,515.99 97.09,515.85 103,513.97 107.14,512.66 111.47,510.79 114.99,508.21 127.24,499.21 127,483.60 127,470 127,428.89 128.76,411.97 119.37,399 112.42,389.42 102.14,387.02 91,387.22 91,387.22 30,387.22 30,387.22 Z"
      />
      <path
        :fill="mainColor"
        d="M 717,396.51 C 711.73,397.85 706.61,399.08 702,402.11 685.90,412.69 687,425.18 687,442 687,442 687,473 687,473 687,489.10 684.82,505.27 697.09,517.96 707.09,528.30 718.82,528 732,528 732,528 775,528 775,528 794.64,527.97 814.73,518.15 815,496 815,496 815,431 815,431 814.98,426.19 814.82,423.61 813.12,419 805.23,397.47 789.84,396 770,396 770,396 748,396 748,396 748,396 717,396.51 717,396.51 Z"
      />
      <path
        :fill="mainColor"
        d="M 1207,408.15 C 1186.79,412.22 1175.25,422.73 1175,444 1175,444 1175,530 1175,530 1175.25,551.43 1187.82,566.97 1210,567 1210,567 1301,567 1301,567 1322.58,566.97 1337.89,554.24 1338,532 1338,532 1338,446 1338,446 1337.97,429.43 1330.74,414.93 1314,409.77 1305.88,407.27 1295.57,408 1287,408.15 1287,408.15 1243,408.15 1243,408.15 1243,408.15 1207,408.15 1207,408.15 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 922,495.15 C 909.40,497.80 898.55,501.76 892.38,514 887.36,523.93 889,537.97 889,549 889,549 889,618 889,618 889.03,639.88 903.16,653.97 925,654 925,654 1014,654 1014,654 1036.15,653.97 1051.96,642.20 1052,619 1052,619 1052,532 1052,532 1051.97,515.15 1043.84,501.47 1027,496.75 1018.02,494.22 1008.28,495 999,495.15 999,495.15 956,495.15 956,495.15 956,495.15 922,495.15 922,495.15 Z"
      />
      <path
        :fill="mainColor"
        d="M 517,526.15 C 498.87,529.94 486.03,540.59 486,560 486,560 486,650 486,650 486.03,670.69 500.31,684.97 521,685 521,685 612,685 612,685 633.95,684.97 648.97,671.25 649,649 649,649 649,565 649,565 648.97,542.62 636.37,526.28 613,526.15 613,526.15 552,526.15 552,526.15 552,526.15 517,526.15 517,526.15 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 718,574.15 C 698.96,578 687.10,588.93 687,609 687,609 687,704 687,704 687.03,724.31 698.34,740.97 720,741 720,741 815,741 815,741 836.24,740.97 849.90,727.20 850,706 850,706 850,613 850,613 849.97,590.98 838.47,574.28 815,574.15 815,574.15 754,574.15 754,574.15 754,574.15 718,574.15 718,574.15 Z"
      />
      <path
        :fill="mainColor"
        d="M 749,780.14 C 742.08,781.43 739.76,781.16 733,784.32 712.33,794 714,808.94 714,828 714,828 714,856 714,856 714,871.28 711.54,888.47 722.33,900.96 732.61,912.87 743.94,912 758,912 758,912 805,912 805,912  824.55,911.97 840.97,900.79 841,880 841,880 841,814 841,814 840.99,808.97 841.12,806.79 839.12,802 831.98,784.85 819.52,780.21 802,780.14 802,780.14 775,780.14 775,780.14 775,780.14 749,780.14 749,780.14 Z"
      />
      <path
        :fill="mainColor"
        d="M 1406.00,78.15 C 1394.10,80.74 1383.05,87.21 1378.47,99.00 1374.91,108.15 1376.00,123.85 1376.00,134.00 1376.00,134.00 1376.00,200.00 1376.00,200.00 1376.27,222.97 1391.40,236.96 1414.00,237.00 1414.00,237.00 1500.00,237.00 1500.00,237.00 1520.99,236.97 1538.96,225.64 1539.00,203.00 1539.00,203.00 1539.00,113.00 1539.00,113.00 1538.97,92.18 1524.80,78.03 1504.00,78.15 1504.00,78.15 1441.00,78.15 1441.00,78.15 1441.00,78.15 1406.00,78.15 1406.00,78.15 Z"
      />
      <path
        :fill="mainColor"
        d="M 1628.00,78.14 C 1606.95,81.89 1588.80,91.97 1581.24,113.00 1576.89,125.09 1578.00,154.10 1578.00,168.00 1578.00,168.00 1578.00,271.00 1578.00,271.00 1578.16,304.39 1597.81,330.95 1633.00,331.00 1633.00,331.00 1781.00,331.00 1781.00,331.00 1812.56,330.95 1837.95,309.41 1838.00,277.00 1838.00,277.00 1838.00,135.00 1838.00,135.00 1837.95,102.72 1815.89,78.05 1783.00,78.14 1783.00,78.14 1682.00,78.14 1682.00,78.14 1682.00,78.14 1628.00,78.14 1628.00,78.14 Z"
      />
      <path
        :fill="mainColor"
        d="M 1407.00,278.15 C 1402.07,279.56 1396.34,281.17 1392.00,283.76 1374.47,294.25 1376.00,309.46 1376.00,327.00 1376.00,327.00 1376.00,354.00 1376.00,354.00 1376.00,369.38 1374.09,386.48 1385.21,398.96 1392.41,407.04 1403.56,409.98 1414.00,410.00 1414.00,410.00 1465.00,410.00 1465.00,410.00 1471.60,409.99 1473.61,409.65 1480.00,407.85 1503.89,401.10 1505.00,382.83 1505.00,362.00 1505.00,362.00 1505.00,337.00 1505.00,337.00 1505.00,321.41 1506.88,304.35 1497.07,291.00 1486.78,277.00 1472.27,278.00 1457.00,278.15 1457.00,278.15 1433.00,278.15 1433.00,278.15 1433.00,278.15 1407.00,278.15 1407.00,278.15 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 1611.00,377.15 C 1599.14,379.66 1588.28,383.78 1582.19,395.00 1576.67,405.16 1578.00,425.26 1578.00,437.00 1578.00,437.00 1578.00,483.00 1578.00,483.00 1578.00,492.91 1577.45,504.50 1580.60,514.00 1585.61,529.13 1598.92,535.98 1614.00,536.00 1614.00,536.00 1704.00,536.00 1704.00,536.00 1725.05,535.97 1740.97,524.08 1741.00,502.00 1741.00,502.00 1741.00,414.00 1741.00,414.00 1740.98,400.93 1735.59,387.06 1723.00,381.19 1710.80,375.50 1695.27,377.00 1682.00,377.15 1682.00,377.15 1637.00,377.15 1637.00,377.15 1637.00,377.15 1611.00,377.15 1611.00,377.15 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 1408.00,456.21 C 1387.98,459.72 1376.10,471.18 1376.00,492.00 1376.00,492.00 1376.00,586.00 1376.00,586.00 1376.10,606.87 1388.12,622.97 1410.00,623.00 1410.00,623.00 1504.00,623.00 1504.00,623.00 1523.87,622.97 1538.97,610.51 1539.00,590.00 1539.00,590.00 1539.00,492.00 1539.00,492.00 1538.98,477.39 1532.26,463.97 1518.00,458.47 1508.80,454.92 1489.46,456.00 1479.00,456.21 1479.00,456.21 1408.00,456.21 1408.00,456.21 Z"
      />
    </svg>
    <svg
      class="makeMeMove"
      viewBox="0 0 2254 1136"
      :style="{
        position: 'absolute',
        width: 1920 * 0.3 + 'px',
        height: 1920 * 0.15 + 'px',
        bottom: 13 + '%',
        right: 12 + '%',
      }"
    >
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 1686,1.15 C 1680.69,2.43 1675.69,3.64 1671,6.48 1656.69,15.13 1658,29.62 1658,44 1658,44 1658,68 1658,68 1658,81.14 1656.51,96.41 1666.21,106.91 1672.63,113.86 1681.90,115.89 1691,116 1691,116 1734,116 1734,116 1739.14,115.99 1744,115.58 1749,114.24 1769.81,108.66 1771,93.24 1771,75 1771,75 1771,53 1771,53 1771,39.57 1772.70,23.35 1764,12 1755.13,0.32 1741.12,1 1728,1.15 1728,1.15 1708,1.15 1708,1.15 1708,1.15 1686,1.15 1686,1.15 Z"
      />
      <path
        :fill="mainColor"
        d="M 1388,74.15 C 1362.81,80 1348,96.71 1348,123 1348,123 1348,250 1348,250 1348,257.41 1349.17,260.17 1351.39,267 1351.39,267 1354.51,275.83 1354.51,275.83 1362.83,292.66 1378.99,299.97 1397,300 1397,300 1520,300 1520,300 1542.71,299.96 1561.89,289.61 1568.66,267 1570.73,260 1570.99,261.61 1571,254 1571,254 1571,122 1571,122 1570.99,113.82 1570.70,116.85 1568.83,109.96 1567.83,106.26 1567,102.50 1565.46,99 1558,83 1543.45,74 1526,74.15 1526,74.15 1436,74.15 1436,74.15 1436,74.15 1388,74.15 1388,74.15 Z"
      />
      <path
        :fill="mainColor"
        d="M 1667,186.14 C 1640.38,190.79 1624,206.17 1624,234 1624,234 1624,363 1624,363 1624,389.90 1641.81,412.96 1670,413 1670,413 1797,413 1797,413 1806.13,412.99 1806.65,412.44 1815,409.37 1836.13,401.58 1845.97,386.29 1846,364 1846,364 1846,238 1846,238 1845.95,208.48 1828.84,186.15 1798,186.14 1798,186.14 1713,186.14 1713,186.14 1713,186.14 1667,186.14 1667,186.14 Z"
      />
      <path
        :fill="mainColor"
        d="M 1971,186.14 C 1971,186.14 1954,189.50 1954,189.50 1954,189.50 1947.91,192.25 1947.91,192.25 1947.91,192.25 1938.28,196 1938.28,196 1923.69,203.87 1911.43,216.56 1905.26,232 1902.30,239.40 1901.91,247.25 1900.79,255 1899.85,261.56 1899,258.30 1899,268 1899,268 1899,314 1899,314 1899,314 1899,464 1899,464 1899,473.72 1900,470.52 1900.89,477 1901.85,484 1902.77,491.21 1905,498 1909.58,511.61 1919.63,526.57 1931.28,535 1931.28,535 1938.91,539.30 1938.91,539.30 1941.32,540.67 1942.37,541.58 1945,542.63 1945,542.63 1963.17,547.77 1963.17,547.77 1974.39,549.90 2013.11,549 2027,549 2027,549 2173,549 2173,549 2182.10,548.99 2184.69,547.90 2193,545.96 2202.80,543.69 2212.12,540.72 2220.83,535.60 2241.66,523.38 2253.96,499.78 2254,476 2254,476 2254,262 2254,262 2253.98,251.44 2252.56,245.65 2248.94,235.91 2237,203.93 2213.41,186 2179,186.14 2179,186.14 2042,186.14 2042,186.14 2042,186.14 1971,186.14 1971,186.14 Z"
      />
      <path
        :fill="mainColor"
        d="M 446,243.15 C 419.79,249.12 406.13,264.89 406,292 406,292 406,417 406,417 406,435.77 413.37,455.53 431.17,464.35 434.86,466.18 438,466.78 441.96,467.83 448.85,469.70 445.82,469.99 454,470 454,470 578,470 578,470 586.76,469.99 583.55,469.48 591,467.59 614.71,461.61 627.96,446.94 628,422 628,422 628,292 628,292 627.96,265.18 611.14,243 583,243.15 583,243.15 493,243.15 493,243.15 493,243.15 446,243.15 446,243.15 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 1017,298.11 C 1017,298.11 1005,299.96 1005,299.96 996.12,301.81 980.77,307.47 973.17,312.35 953.46,325 942,346.78 942,370 942,370 942,586 942,586 942,598.22 944.85,608.10 949.97,619 962.66,646.10 986,660.95 1016,661 1016,661 1217,661 1217,661 1243.83,660.96 1273.32,647 1286.65,623 1293.51,610.64 1295.98,594 1296,580 1296,580 1296,383 1296,383 1295.99,375.89 1294.12,359.62 1292,353 1289.35,344.63 1285.43,336.40 1280.73,329 1275.60,320.91 1268.13,314.46 1260,309.55 1235.98,295 1208.97,298 1182,298.11 1182,298.11 1100,298.11 1100,298.11 1100,298.11 1047,298.11 1047,298.11 1047,298.11 1017,298.11 1017,298.11 Z"
      />
      <path
        :fill="mainColor"
        d="M 725,355.14 C 710,357.87 693.90,364.80 686.68,379.17 684.22,384 681,395.53 681,401 681,401 681,432 681,432 681,432 681,532 681,532 681,540.16 681.33,538.54 683.36,546 684.37,549.70 685.26,553.52 686.91,557 694.60,573.26 710.46,581.97 728,582 728,582 855,582 855,582 864.16,581.99 866.66,581.25 875,577.65 891.10,570.70 897.67,562.81 902,546 903.82,539 903.99,540.51 904,533 904,533 904,406 904,406 903.98,397.73 903.42,399.47 901.59,392 895.70,367.94 879.92,355.12 855,355.14 855,355.14 771,355.14 771,355.14 771,355.14 725,355.14 725,355.14 Z"
      />
      <path
        :fill="mainColor"
        d="M 1359,576 C 1368.26,576.29 1367.11,579.29 1375,582.55 1384.76,586.57 1391.42,587.98 1402,588 1402,588 1516,588 1516,588 1525.10,587.99 1527.64,587.26 1536,584.67 1553.77,579.19 1563.73,571.43 1568.80,553 1570.44,547 1570.96,547.46 1571,541 1571,541 1571,409 1571,409 1570.99,400.32 1570.50,403.44 1568.59,395.99 1567.78,392.82 1566.60,388 1565.24,385.17 1557.14,367.88 1540.25,360.22 1522,360 1522,360 1402,360 1402,360 1383.35,360 1362.35,366.90 1353.71,385 1345.69,401.80 1348,420.93 1348,439 1348,439 1348,535 1348,535 1348,543.83 1350.51,552.76 1353.71,560.96 1356.59,568.34 1358.76,566.21 1359,576 Z"
      />
      <path
        :fill="mainColor"
        d="M 74,467.11 C 42.30,471.95 15.48,483.94 3.63,516 0.52,524.43 0,523.62 0,533 0,533 0,761 0,761 0,771.49 0.66,768.43 3.33,777 9,795.55 18.79,810.88 36.17,820.63 36.17,820.63 44.96,824.35 44.96,824.35 54.95,828.46 62,829.98 73,830 73,830 275,830 275,830 303.85,829.96 338.16,812.61 347.96,784 347.96,784 352.74,766 352.74,766 354.85,753.34 354,713.27 354,698 354,698 354,552 354,552 353.98,540.93 352.43,535.44 349.87,525 347.63,515.89 345.92,511.20 341.25,503 338.28,497.77 335.40,494.15 331.27,489.85 305.51,463 272.91,467 239,467.11 239,467.11 155,467.11 155,467.11 155,467.11 103,467.11 103,467.11 103,467.11 74,467.11 74,467.11 Z"
      />
      <path
        :fill="mainColor"
        d="M 1664,473.15 C 1647.46,476.50 1631.40,487.41 1626,504 1623.24,512.72 1624,525.67 1624,535 1624,535 1624,587 1624,587 1624,607 1621.19,627.55 1634.79,644.28 1649.92,662.91 1666.50,661 1688,661 1688,661 1748,661 1748,661 1764.74,660.97 1783,653.73 1791.87,638.72 1796.79,630.34 1798.98,618.64 1799,609 1799,609 1799,524 1799,524 1798.91,516.20 1797.89,514 1795.81,506.96 1794,501.12 1793.23,498.24 1789.82,493 1785.29,486 1780.51,481.53 1773,477.97 1759.50,471.54 1754.47,473 1740,473.15 1740,473.15 1711,473.15 1711,473.15 1711,473.15 1664,473.15 1664,473.15 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 451,529.14 C 445.71,530.29 439.93,531 435,533.17 415.32,541.69 406.10,556.94 406,578 406,578 406,705 406,705 406,721.57 413.37,740.69 428.17,749.59 437.38,755.13 448.41,756.98 459,757 459,757 573,757 573,757 602,756.95 627.95,741.75 628,710 628,710 628,578 628,578 627.97,559 618.33,540 600,532.61 587.64,527.59 561.99,529 548,529.14 548,529.14 485,529.14 485,529.14 485,529.14 451,529.14 451,529.14 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 1943,615.14 C 1928.54,617.80 1911.45,626.17 1904.95,640 1902.51,645.31 1901.84,650.46 1900.83,656 1900.83,656 1899,663 1899,663 1899,663 1899,694 1899,694 1899,694 1899,787 1899,787 1899,795.59 1899.68,792.96 1900.96,800 1901.93,805.30 1903,812.17 1905.42,817 1913.34,832.85 1928.44,841.97 1946,842 1946,842 2073,842 2073,842 2089.27,841.97 2107.28,834.12 2115.86,819.72 2120.97,811.14 2122.98,797.89 2123,788 2123,788 2123,671 2123,671 2122.99,663.59 2122.27,657.95 2120,650.91 2118.17,644.77 2117.54,641.66 2113.91,636 2098.80,612.40 2077.28,615 2053,615.14 2053,615.14 2004,615.14 2004,615.14 2004,615.14 1943,615.14 1943,615.14 Z"
      />
      <path
        :fill="mainColor"
        d="M 722,642.11 C 717.77,643.32 707.84,646.79 704,648.81 689.72,656.54 681,672.94 681,689 681,689 681,707 681,707 681,707 681,755 681,755 681,755 681,781 681,781 681,791.16 686.60,807 693.36,814.71 708.63,831.94 724.32,830 745,830 745,830 806,830 806,830 812.17,829.99 818,829.21 823.91,827.34 823.91,827.34 834.96,822.10 834.96,822.10 857.50,809.22 856,785.38 856,763 856,763 856,722 856,722 856,708 857.21,685.89 852.96,673 852.96,673 846.80,661.17 846.80,661.17 839.76,650.36 824.87,642.15 812,642.11 812,642.11 794,642.11 794,642.11 794,642.11 757,642.11 757,642.11 757,642.11 722,642.11 722,642.11 Z"
      />
      <path
        :fill="mainColor"
        d="M 1396,659.14 C 1390.23,660.26 1385.80,660.51 1380,662.45 1370,665.85 1359.41,673.92 1354.19,683.17 1346.28,697.16 1348,719.27 1348,735 1348,735 1348,836 1348,836 1348.10,843.89 1349,845.94 1351.38,853 1352.34,855.90 1353,859.18 1354.40,861.83 1363.54,879.42 1379.90,886.97 1399,887 1399,887 1518,887 1518,887 1528.62,886.98 1531.47,886.12 1541,882.37 1556.71,876.23 1564.45,868.23 1569,852 1570.89,845.62 1570.99,846.89 1571,840 1571,840 1571,708 1571,708 1570.99,700 1570.80,702.81 1568.81,695.96 1567.74,692.32 1566.90,688.45 1565.30,685 1560.81,675.30 1551,665.90 1540.91,662.24 1529,657.96 1501.47,659 1488,659.14 1488,659.14 1429,659.14 1429,659.14 1429,659.14 1396,659.14 1396,659.14 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 1670,727.71 C 1657,731.54 1655.65,729.19 1642.98,737.40 1638.43,740.34 1635.85,742.55 1632.61,747 1630.85,749.40 1627.40,755.28 1626.45,758 1622.86,768.77 1624,790 1624,802 1624,802 1624,918 1624,918 1624,944.53 1641.17,966.96 1669,967 1669,967 1798,967 1798,967 1817.15,966.97 1836.14,956.24 1843.22,937.83 1845.26,932.53 1845.99,924.68 1846,919 1846,919 1846,779 1846,779 1845.99,772.94 1845.26,766.89 1843.62,761 1842.68,757.70 1841,755 1839.54,751.99 1831.97,736.70 1821.73,732 1806,728.78 1799.31,727.39 1801.89,727 1794,727 1794,727 1779,727 1779,727 1779,727 1750,727 1750,727 750,727 1722,727 1722,727 1722,727 1689,727 1689,727 1683.12,727 1675.61,726.50 1670,727.71 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 1001,784 C 982.94,787.39 966.33,797.18 959.80,815.17 956.31,824.77 957,851.74 957,863 957,863 957,956 957,956 957,977.11 964.98,999.69 986.17,1008.21 991.36,1010.30 998.43,1010.99 1004,1011 1004,1011 1131,1011 1131,1011 1148,1010.97 1164.94,1003.37 1173.42,988 1174.93,985.37 1176.11,984 1177,980.96 1180.94,968.53 1180,943.71 1180,930 1180,930 1180,839 1180,839 1179.99,832 1178.96,823.71 1177.11,817 1175.85,812.41 1174.41,810 1172,806 1163.36,791.57 1148.56,784 1132,784 1132,784 1119,784 1119,784 1119,784 1091,784 1091,784 1091,784 1061,784 1061,784 1061,784 1001,784 1001,784 Z"
      />
      <path
        :fill="mainColor"
        d="M 454,828.14 C 449.14,829.13 442.83,829.53 438.28,831.27 417,839.41 406.27,854.30 406,877 406,877 406,1004 406,1004 406.10,1025.33 416,1045.47 437,1053.19 442.34,1055.16 451.26,1055.99 457,1056 457,1056 575,1056 575,1056 603.89,1055.95 627.95,1039.92 628,1009 628,1009 628,877 628,877 627.97,856.76 616.62,837.68 597,830.83 586.48,827.16 557.33,828 545,828.14 545,828.14 486,828.14 486,828.14 486,828.14 454,828.14 454,828.14 Z"
      />
      <path
        style="opacity: .5"
        :fill="mainColor"
        d="M 727.42,896.68 C 715.35,900.81 715.67,897.22 702,905.55 697.63,908.22 694.90,910.11 691.58,914.17 685.93,921 681,934 681,943 681,943 681,970 681,970 681,970 681,1087 681,1087 681,1094.90 681.36,1092.93 683.17,1100 688.65,1121.39 703,1135.96 726,1136 726,1136 856,1136 856,1136 872.91,1135.97 890.49,1127.33 898.46,1111.83 900.10,1108.64 900.94,1104.47 901.83,1101 903.64,1093.93 903.98,1095.90 904,1088 904,1088 904,948 904,948 903.98,940 903.18,940.37 901.35,933 900.29,928.75 898.77,923 896.43,919.42 887.62,905.63 879.66,901 864,897.96 858.84,896.94 860.31,896.10 854,896 854,896 829,896 829,896 829,896 779,896 779,896 779,896 746,896 746,896 740.64,896 732.38,895.50 727.42,896.68 Z"
      />
      " />
    </svg> -->
    <div
      v-for="(itm, index) in items"
      :key="'first-step-item-' + index"
      :style="{
        width: itm.style.width + '%',
        top: itm.style.top + '%',
        left: itm.style.left + '%',
        cursor: itm.style.cursor,
        top: itm.style.top + '%',
        bottom: itm.style.bot + '%',
        left: itm.style.left + '%',
        right: itm.style.right + '%',
        background: itm.style.bcg,
        width: itm.style.width + '%',
        height: itm.style.height + '%',
        opacity: itm.style.opacity,
        color: itm.style.color || mainColor,
        transform: itm.style.transform,
        position: 'absolute',
      }"
    >
      <img
        v-if="itm.type == 'img'"
        :class="itm.style.class"
        :style="{
          width: '100%',
          height: '100%',
          cursor: itm.style.cursor,
          objectPosition: itm.style.objectPosition | 'left bottom',
          animationDelay: (itm.style.delay | 0) / 100 + 's',
        }"
        :src="itm.content"
      />
      <div
        class="box"
        @click="firstStepOff()"
        v-if="itm.type == 'text'"
        :class="itm.style.class + ' ' + itm.style.hover"
        :style="{
          animationDelay: (itm.style.delay | 0) / 100 + 's',
          borderColor: mainColor,
        }"
      >
        <p
          :class="itm.style.class + ' ' + itm.style.hover"
          :style="{
            width: '100%',
            fontSize: itm.style.fontSize + 'rem',
            margin: itm.style.margin || 0,
            fontFamily: itm.style.font || 'Arial',
            animationDelay: (itm.style.delay | 0) / 100 + 's',
          }"
          v-html="itm.content"
        ></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'firs-step',
  components: {},
  props: {
    desc: {
      type: String,
      default: function() {
        return '';
      },
    },
    mainColor: {
      type: String,
      default: function() {
        return '#309de4';
      },
    },
    items: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  mounted() {
    if (this.items.length == 0) {
      this.firstStepOff();
    }
  },
  methods: {
    firstStepOff() {
      this.$emit('firsstepoff');
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
  },
  computed: {
    currentSlide() {
      return this.$store.getters.getCurrentStep;
    },
  },
};
</script>
<style lang="sass">
@import '../../style/base'
.first-step
  top: 0
  left: 0
  position: fixed
  width: 100%
  height: 100%
  background: transparent
  z-index: 1000
  .box
    text-align: center
    width: 100%
    height: 100%
    background: white
    border: calc(1080px * 0.015) solid $MAC_MAIN_COLOR
    border-radius: 1em
    cursor: pointer
    display: flex
    justify-content: center
    align-items: center

  h2
    position: absolute
    top: 50%
    transform: translate(0, -50%)
    width: 100%
    margin: auto
    font-size: 4rem
    font-family: Alber-Bold_2, sans-serif
</style>
